import { render } from "./materialCDRView.vue?vue&type=template&id=a3967df2"
import script from "./materialCDRView.vue?vue&type=script&lang=js"
export * from "./materialCDRView.vue?vue&type=script&lang=js"

import "./materialCDRView.vue?vue&type=style&index=0&id=a3967df2&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__